import { PageHero } from "@/src/components/PageHero";
import { ArticleGrid } from "./(sections)/ArticleGrid";
import { Newsletter } from "@/src/pages/home/(sections)/newsletter/Newsletter";

export function JournalPage() {
    return (
        <>
            <PageHero
                image="https://images.unsplash.com/photo-1570823635306-250abb06d4b3?auto=format&fit=crop&q=80&w=2000"
                label="Stories & Ideas"
                title="The Journal"
            />
            <ArticleGrid />
            <Newsletter />
        </>
    );
}
